import { Header } from "../../components/header/header";
import { Footer } from "../../components/footer/footer";
import { WebsiteCard } from "../../components/cards/project-card";
import { MotionFrame } from "../../components/utilities/framer";
import "../../styles/portfolio.css";
import { websiteData } from "../../mock-data/card.data";


export const WebsitePortfolio = () => {
    return (
        <div className="rand-page">
            <Header pageTitle={"Website portfolio"} />
            <div className="card-page">
                <MotionFrame>
                    <div className="page-sub-cap">
                        <span className="norm-text">Our Recent </span>
                        <span className="gradient-text">Website Projects</span>
                    </div>
                </MotionFrame>
                <div className="flx flx-w card-box">
                    {websiteData.map((data, indx) => (
                        <WebsiteCard
                            key={indx}
                            title={data.title}
                            description={data.description}
                            image={data.image}
                            url={data.url}
                        />

                    ))}
                </div>
            </div>
            <Footer />
        </div>
    )
}